import { API_ROUTES_FOR_AXIOS } from '../constants/ApiRoutes';
import { axiosInstance } from '../constants/axiosInstance';
import { ApiResponse } from 'src/types/commonResponseTypes';
import {
  DnsVerificationApiResponse,
  IsDnsVerified,
  DnsVerificationPayload,
} from 'src/types/dnsVerification';
import { handleError } from 'src/utils/commonErrorUtils';

export const createDnsVerificationCode = async (
  body: DnsVerificationPayload,
): Promise<ApiResponse<DnsVerificationApiResponse>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['createDnsVerificationCode']();
    const { data } = await axiosInstance.post(apiUrl, body);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const findDnsVerificationDetailsByOrgIdAndMongoUserId =
  async (): Promise<ApiResponse<DnsVerificationApiResponse>> => {
    try {
      const apiUrl = API_ROUTES_FOR_AXIOS['findDnsVerificationDetails']();
      const { data } = await axiosInstance.get(apiUrl);

      return data;
    } catch (error) {
      return handleError(error);
    }
  };

export const verifyDnsByOrgIdAndUserId = async (
  body: DnsVerificationPayload,
): Promise<ApiResponse<IsDnsVerified>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS['verifyDnsByOrgIdAndUserId']();
    const { data } = await axiosInstance.post(apiUrl, body);

    return data;
  } catch (error) {
    return handleError(error);
  }
};
